import { DisplayKey } from "@/models/auth";
import { useAuthUser } from "@/hooks/useAuthUser";
import { useCallback } from "react";

export const useAuthChecker = () => {
  const { user } = useAuthUser();

  const authChecker = useCallback(
    (key: DisplayKey): boolean => {
      try {
        if (user && user.auth) {
          if (user?.auth[key] === undefined) {
            console.error(`${key}の画面権限が未定義です。`);
            return false;
          }
          return user?.auth[key];
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    },
    // authの変更のみ
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user?.auth]
  );

  return {
    authChecker,
  };
};
